// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"346cdde6","271":"1e672633","453":"130d29ad","690":"a70d0052"}[chunkId] + ".chunk.js";
};